// project imports
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import Validator from "validatorjs";
import * as keys from "./keys";
import moment from "moment";
class Utils {
  defermentPeriodOptionList = (ppt, annuityOption) => {
    let defermentPeiodlist = []
    // if (annuityOption === "1" || annuityOption === "2") {
    switch (ppt) {
      case "1":
        defermentPeiodlist = [
          { label: "5", id: "11" },
          { label: "6", id: "12" },
          { label: "7", id: "13" },
          { label: "8", id: "14" },
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;
      case "5":
        defermentPeiodlist = [
          { label: "5", id: "11" },
          { label: "6", id: "12" },
          { label: "7", id: "13" },
          { label: "8", id: "14" },
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;
      case "6":
        defermentPeiodlist = [
          { label: "6", id: "12" },
          { label: "7", id: "13" },
          { label: "8", id: "14" },
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]

        break;
      case "7":
        defermentPeiodlist = [
          { label: "7", id: "13" },
          { label: "8", id: "14" },
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;
      case "8":
        defermentPeiodlist = [
          { label: "8", id: "14" },
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;
      case "9":
        defermentPeiodlist = [
          { label: "9", id: "15" },
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;
      case "10":
        defermentPeiodlist = [
          { label: "10", id: "16" },
          { label: "12", id: "17" }
        ]
        break;

      default:
        break;
    }
    // } else {
    // switch (ppt) {
    //   case "1":
    //     defermentPeiodlist = [
    //       { label: "5", id: "11" },
    //       { label: "10", id: "16" },

    //     ]
    //   case "5":
    //     defermentPeiodlist = [
    //       { label: "5", id: "11" },
    //       { label: "10", id: "16" },

    //     ]
    //     break;
    //   case "6":
    //     defermentPeiodlist = [
    //       { label: "6", id: "12" },
    //       { label: "10", id: "16" },
    //     ]

    //     break;
    //   case "7":
    //     defermentPeiodlist = [
    //       { label: "7", id: "13" },
    //       { label: "10", id: "16" },
    //     ]
    //     break;
    //   case "8":
    //     defermentPeiodlist = [
    //       { label: "8", id: "14" },
    //       { label: "10", id: "16" },
    //     ]
    //     break;
    //   case "9":
    //     defermentPeiodlist = [
    //       { label: "9", id: "15" },
    //       { label: "10", id: "16" },
    //     ]
    //     break;
    //   case "10":
    //     defermentPeiodlist = [
    //       { label: "10", id: "16" }
    //     ]
    //     break;

    //   default:
    //     break;
    // }

    // }
    return defermentPeiodlist;
  };

  annuityOptionList(annuity_benefit) {
    let optionList = []

    switch (annuity_benefit) {
      case "1":
        optionList = [
          {
            label: "Immediate Life Annuity",
            id: "5"
          },
          {
            label:
              "Immediate Life Annuity with Return of Purchase Price on Death",
            id: "6",
          },
        ]
        break;

      case "2":
        optionList = [
          {
            label:
              "Deferred Life Annuity",
            id: "7",
          },
          {
            label:
              "Deferred Life Annuity with Return of Purchase Price on Death",
            id: "8",
          },
        ]
        break;

      default:
        break;
    }
    return optionList
  }


  // ! get total price
  getTotalPrice = (biResponse) => {
    try {
      let totalPremium = 0;
      totalPremium += Number(biResponse.TOTAL_PREM_TAX);
      return totalPremium;
    } catch (e) {
      return 0;
    }
  };

  // ! update BI data
  updateBi = async (key, value, productId, form, productData) => {
    let selectedRiskType = productData?.data?.selectedRisk === "medium" ? "low" : productData?.data?.selectedRisk;
    let selectedRiskProductObject = productData?.data?.BI.filter((item) => item.risk == selectedRiskType)[0];
    let biData = OptimizationStore.fetchBiRequest(productId, selectedRiskProductObject.family_product_id);
    let biRequest = biData.data.bi_request;

    switch (key) {

      case keys.PR_PPT:
        biRequest[keys.PR_PPT] = value?.ppt;
        biRequest[keys.DEFERMENT_PERIOD] = value?.defermentPeiod
        break;

      case keys.FREQUENCY:
        biRequest[keys.FREQUENCY] = value?.frequency;
        break;

      case keys.SOURCE_OF_PURCHASE_PRICE:
        biRequest[keys.PRAN_NUMBER] = value.pranNo;
        biRequest[keys.SOURCE_OF_PURCHASE_PRICE] = value.sourceOfPP;
        break;

      case keys.PRAN_NUMBER:
        biRequest[keys.PRAN_NUMBER] = value;
        break;

      case keys.ANNUITY_BENEFIT:
        biRequest[keys.ANNUITY_BENEFIT] = value.annuityBenefitValue;
        biRequest[keys.DEFERMENT_PERIOD] = value.defermentPeriodValue;
        break;

      case keys.LIFE_STATUS:
        biRequest[keys.LIFE_STATUS] = value.lifeStatus;
        biRequest[keys.ANNUITY_OPTION] = value.annuityOption;
        break;

      case keys.ANNUITY_MODE:
        biRequest[keys.ANNUITY_MODE] = value;
        //let targetAmount = Number(biRequest?.TargetAmount);
        // switch (value) {
        //   case "21":
        //   case 21:
        //     biRequest["TargetAmount"] = Math.round(targetAmount / 1);
        //     biRequest["ReverseCalcFlag"] = 1;
        //     biRequest[keys.PREMIUM] = 0;
        //     break;
        //   case "22":
        //   case 22:
        //     biRequest["TargetAmount"] = Math.round(targetAmount / 2);
        //     biRequest["ReverseCalcFlag"] = 1;
        //     biRequest[keys.PREMIUM] = 0;
        //     break;
        //   case "23":
        //   case 23:
        //     biRequest["TargetAmount"] = Math.round(targetAmount / 4);
        //     biRequest["ReverseCalcFlag"] = 1;
        //     biRequest[keys.PREMIUM] = 0;
        //     break;
        //   case "24":
        //   case 24:
        //     biRequest["TargetAmount"] = Math.round(targetAmount / 12);
        //     biRequest["ReverseCalcFlag"] = 1;
        //     biRequest[keys.PREMIUM] = 0;
        //     break;
        // }
        break;

      case keys.PURCHASE_PRICE:
        biRequest[keys.PURCHASE_PRICE] = value;
        break;

      case keys.DEFERMENT_PERIOD:
        biRequest[keys.DEFERMENT_PERIOD] = value;
        break;

      case keys.ANNUITY_OPTION:
        biRequest[keys.ANNUITY_OPTION] = value;
        break;

      case keys.ANNUITY_OPTION_BESIS:
        biRequest[keys.ANNUITY_OPTION_BESIS] = value;
        break;

      case keys.NAME_OF_THE_SECONDARY_ANNUITANT:
        biRequest[keys.NAME_OF_THE_SECONDARY_ANNUITANT] = value;
        break;

      case keys.DOB_NAME_OF_THE_SECONDARY_ANNUITANT:
        // ! for passing dob
        let dob = value ? moment(value).format("DD MMM YYYY") : ""
        biRequest[keys.THE_SECONDARY_ANNUITANT_DOB] = dob;

        // !for passing age
        let age = value ? moment().diff(moment(value, "DD MMM YYYY"), "years").toString() : ""
        biRequest[keys.DOB_NAME_OF_THE_SECONDARY_ANNUITANT] = age;

        break;

      case keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT:
        biRequest[keys.GENDER_NAME_OF_THE_SECONDARY_ANNUITANT] = value;
        break;

      case keys.PREMIUM:
        biRequest[keys.PREMIUM] = value;
        break;

      case keys.INCOME:
        biRequest[keys.INCOME] = value;
        break;
      case keys.ACCRUALOFSURVIVALBENEFIT_1:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1] = value.asb1;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStartYear1;
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEndYear1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_1:
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStart1
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_1:
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;

        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_1:

        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_1] = value

        break

      case keys.ACCRUALOFSURVIVALBENEFIT_2:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_2:
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_2:
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_2:
        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_2] = value

        break

      case keys.ACCRUALOFSURVIVALBENEFIT_3:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_3:
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3
        break;

      case keys.ASB_ENDPOLICYYEAR_3:
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_3:
        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_3] = value

        break

      default:
        break;
    }

    OptimizationStore.updateBiRequest(productId, biRequest, productData.data.family_product_id, key, value);

  };

  newPolicyTimeLineData(element, inputString, index) {
    const { ANN_PREM_YEARLY, MODAL_ANNUITY_PAYOUT, DB_G } = element;

    const annuityMode = inputString.find(item => item.Key === '@PR_OPTION_7').Value

    const annuityModeObj = { 'Yearly': 1, 'Half-Yearly': 2, 'Quarterly': 4, 'Monthly': 12 }

    // yearly:'21',Half-Yearly':'22',Quarterly:'23',Monthly:'24'

    let youGetValue = MODAL_ANNUITY_PAYOUT

    switch (annuityMode) {
      case '21':
        youGetValue = youGetValue * annuityModeObj['Yearly']
        break;

      case '22':
        youGetValue = youGetValue * annuityModeObj['Half-Yearly']
        break;

      case '23':
        youGetValue = youGetValue * annuityModeObj['Quarterly']
        break;

      case '24':
        youGetValue = youGetValue * annuityModeObj['Monthly']
        break;

      default:
        break;
    }

    let data = {
      youPay: Math.round(ANN_PREM_YEARLY),
      youGet: Math.round(youGetValue),
      lifeCover: Math.round(DB_G),
    };

    return data;
  }

  generatePredefinedOptListForLP(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i < 100; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }

  generatePredefinedOptListForWithDrawalParcentage(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i <= 100; i++) {
      list.push({
        id: startOptId,
        label: i + '%',
      });
      startOptId += 1
    }
    return list
  }


  setHideAndResetValue(formRef, key, value, noOptParamValue) {
    formRef.$(key).set("extra", { ...formRef.$(key).extra, hide: value });
    if (noOptParamValue) {
      formRef.$(key).set("value", { label: "No", id: noOptParamValue });
    } else {
      formRef.$(key).set("value", "");
    }
  }

  handleASBstartPolicyOneConditions(formRef, productName, PT_value, liAge) {

    if (Number(formRef.$("accrual-of-survival-benefit").value.id) == 24) {
      let asbStartYearOneList = this.fetchASBstartPolicyOne(
        // formRef.$("plan-option").value.id,
        PT_value,
        formRef.$("premium-term").value.id,
        formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList,
        liAge
      );

      console.log("asbStartYearOneList ", asbStartYearOneList)

      formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
      });
      formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);


      let selectedAsbStartYearOne = asbStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(1st-opt-in)").value.id
      );
      // if (productName === ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM ||
      //   productName === ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM) {
      //   if (Number(formRef.$("plan-option").value.id) === 2) {
      //     let selectedAsbStartYearOne = asbStartYearOneList.some(
      //       (item) =>
      //         Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
      //     );
      //     if (selectedAsbStartYearOne) {
      //       formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList.find(
      //         (item) =>
      //           Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
      //       ));
      //     } else {
      //       formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);
      //     }

      //   } else {
      //     formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);
      //   }
      // } else {
      //   formRef
      //     .$("asb-start-age-(1st-opt-in)")
      //     .set("value", asbStartYearOneList[0]);
      // }
      // if (!selectedAsbStartYearOne) {
      // }

      let asbEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(1st-opt-in)").value.id,
        asbStartYearOneList,
        formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
      });

      let selectedAsbEndYearOne = asbEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(1st-opt-in)").value.id
      );
      // if (!selectedAsbEndYearOne) {
      formRef
        .$("asb-end-age-(1st-opt-in)")
        .set("value", asbEndYearOneList[asbEndYearOneList.length - 1]);
      // }
    }
  }


  // handled ASB 1
  handleAsbCondition(formRef, asb1Value) {
    if (Number(asb1Value) === 25) {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", true, 330);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", false);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", false, 330);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    }
  }

  // handled ASB start year 1
  fetchASBstartPolicyOne(pt, ppt, preDefinedOptList, liAge) {
    let startYearList = [];
    // let value = Number(pt) === 40 ? Number(pt) - 1 : Number(pt);
    let value = Number(pt) - 1;
    let startPoint = liAge;
    // if (Number(planOption) === 2) startPoint = Number(Number(ppt) + 2);
    for (let i = startPoint; i < 100; i++) {
      let optData = preDefinedOptList.find((item) => item.label === i)
      startYearList.push(optData);
    }
    return startYearList;
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList.forEach((item) => {
      if (item.id >= startYear1) {
        let optData = preDefinedOptList.find((opt) => opt.label === item.label)
        endYearList.push(optData);
      }
    });
    return endYearList;
  }

  // handled ASB 2nd year condition
  handleAsbTwoCondition(formRef, asb2Value) {

    if (Number(asb2Value) === 330) {
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", false);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", false, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);

    }
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList.forEach((item) => {
      if (item.id >= startYear1) {
        let optData = preDefinedOptList.find((opt) => opt.label === item.label)
        endYearList.push(optData);
      }
    });
    return endYearList;
  }

  // handled ASB 3rd year condition
  handleAsbThreeCondition(formRef, asb3Value) {

    if (Number(asb3Value) === 635) {
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);

    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", false);
    }
  }

  handleASBFirstStartEndCondition(formRef, asbValue) {

    if (Number(asbValue) === 25) {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", true, 330);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", false, 330);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    }
  }

  handleASBTwostartPolicyOneConditions(formRef) {

    if (formRef.$("accrual-of-survival-benefits-year-2").value.id == 329) {
      let asbTwoStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(1st-opt-in)").value.id + 1,
        formRef.$("asb-end-age-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
      });

      let selectedAsbTwoStartYearOne = asbTwoStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoStartYearOne) {
        formRef
          .$("asb-start-age-(2nd-opt-in)")
          .set("value", asbTwoStartYearOneList[asbTwoStartYearOneList.length - 1]);
      }

      let asbTwoEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(2nd-opt-in)").value.id,
        asbTwoStartYearOneList,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
      });

      let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoEndYearOne) {
        formRef
          .$("asb-end-age-(2nd-opt-in)")
          .set("value", asbTwoEndYearOneList[asbTwoEndYearOneList.length - 1]);
      }
    }
  }
  // Handled ASB 2 Start Year 
  handleASBTwoStartEndCondition(formRef, asbValue) {

    if (Number(asbValue) === 330) {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
    } else {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", false, 635);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
    }
  }

  // Handled ASB 3 Start Year 
  handleASBThreestartPolicyOneConditions(formRef) {
    if (formRef.$("accrual-of-survival-benefits-year-3").value.id == 634) {
      let asbThreeStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(2nd-opt-in)").value.id + 1,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
      });

      let selectedAsbThreeStartYearOne = asbThreeStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeStartYearOne) {
        formRef
          .$("asb-start-age-(3rd-opt-in)")
          .set("value", asbThreeStartYearOneList[asbThreeStartYearOneList.length - 1]);
      }

      let asbThreeEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(3rd-opt-in)").value.id,
        asbThreeStartYearOneList,
        formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
      });

      let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeEndYearOne) {
        formRef
          .$("asb-end-age-(3rd-opt-in)")
          .set("value", asbThreeEndYearOneList[asbThreeEndYearOneList.length - 1]);
      }
    }
  }

  defermentPeriodList(value) {

    switch (value) {
      case "9":
        return { label: "0", id: "9" };
    
      case "10":
        return { label: "1", id: "10" };
    
      case "11":
        return { label: "5", id: "11" };
    
      case "12":
        return { label: "6", id: "12" };
    
      case "13":
        return { label: "7", id: "13" };
    
      case "14":
        return { label: "8", id: "14" };
    
      case "15":
        return { label: "9", id: "15" };
    
      case "16":
        return { label: "10", id: "16" };
    
      case "17":
        return { label: "12", id: "17" };
    
      case "947":
        return { label: "15", id: "947" };
    
      case "948":
        return { label: "20", id: "948" };
    
      case "949":
        return { label: "25", id: "949" };
    
      case "950":
        return { label: "30", id: "950" };
    
      default:
        return {};
    }    

  }
}

export default new Utils();
